import React, { useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import TagManager from 'react-gtm-module'
import { Link, useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { DisplayEventsEventNoProduct } from '../../@types/exhibition'
import { AllCategoryFlatCategory } from '../../@types/product'
import '../../css/Product.css'
import { sendSetAppsflyerEvent } from '../../js/postMessage_bak'
import { formatNumberWithTruncation, onErrorImg, plusComma } from '../../js/script'
import { IMAGE_PATH } from '../../pages/util/common'
import LikeBtn from '../btn/LikeBtn'
import { Button } from '../Button'
import { useAppContext } from '../provider/AppProvider'
import { useCommonContext } from '../provider/CommonProvider'
import { IconStarOn } from '../svg/IconSvg'
import { AFWebLinkType, RNPostMessage } from '../../js/postMessage'

interface ProductItemProps {
  data: DisplayEventsEventNoProduct
  index: number
  totalCount?: number
  promotion_id?: string
  promotion_name?: string
  categoryData: any
  setCartIdx: React.Dispatch<React.SetStateAction<number>>
  setIsModal: React.Dispatch<React.SetStateAction<boolean>>
  setSelectProductNo: React.Dispatch<React.SetStateAction<string>>
  item_category: any
  item_category2: any
  item_category3: any
}

const ProductItem: React.FC<ProductItemProps> = ({
  data,
  index,
  totalCount,
  promotion_id,
  promotion_name,
  categoryData,
  setCartIdx,
  setIsModal,
  setSelectProductNo,
  item_category,
  item_category2,
  item_category3,
}) => {
  const [disCountAcc, setDisCountAcc] = useState<number>(0)
  const { isAppView } = useAppContext()
  const { hasAccessToken } = useCommonContext()
  const navigate = useNavigate()

  const calculateDiscountPrice = () => Number(data.salePrice) - Number(data.immediateDiscountAmt)

  const onSendGtmEvent = (eventType: string, eventData: object) => {
    const event = { event: eventType, ecommerce: eventData }
    if (isAppView) {
      sendSetAppsflyerEvent({ eventName: eventType, eventType: eventData })
    } else {
      TagManager.dataLayer({ dataLayer: event })
    }
  }

  const findFirstCategory = () => {
    return categoryData.find((item: AllCategoryFlatCategory) => {
      return item.depth2CategoryNo === item_category.categoryNo
    })
  }

  const handleNavigation = (e: any) => {
    e.preventDefault()
    const firstCategory = findFirstCategory()
    const gtmEventData = {
      item_list_count: totalCount,
      items: [
        {
          item_id: String(data.productNo),
          item_name: data.productName,
          affiliation: '어바웃피싱',
          item_list_price: data.salePrice,
          item_selling_price: calculateDiscountPrice(),
          item_total_discount: data.immediateDiscountAmt,
          discount: 0,
          index: index,
          price: (data?.salePrice || 0) - (data?.immediateDiscountAmt || 0),
          item_brand: data.brandName,
          item_category: firstCategory?.depth1Label || '전체',
          item_category2: item_category2,
          item_category3: item_category3,
          promotion_id,
          promotion_name,
        },
      ],
    }
    onSendGtmEvent('select_promotion', gtmEventData)
    if (isAppView) {
      RNPostMessage(AFWebLinkType.moveToLink, {
        url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/product/${
          data.productNo
        }?items=${JSON.stringify(gtmEventData.items)}`,
      })
    } else {
      navigate(`/product/${data.productNo}`, { state: { items: gtmEventData.items } })
    }
  }

  useEffect(() => {
    if (data && data.salePrice) {
      setDisCountAcc(Number(formatNumberWithTruncation(calculateDiscountPrice() * 0.1).replace(',', '')))
    }
  }, [data])

  return (
    <div className='product_item_wrap'>
      {/* 상품 이미지 */}
      <div className='product_image_area item_img'>
        {data.isSoldOut && (
          <div className='soldout'>
            <img src={`${IMAGE_PATH}/img_soldout.png`} alt='Sold Out' />
          </div>
        )}
        <LikeBtn
          item={data}
          depthLabel={categoryData?.depth1Label || '전체'}
          promotion_id={Number(promotion_id)}
          promotion_name={promotion_name}
          idx={index}
        />
        {data.stickerInfos
          ?.filter((sticker: any) => sticker.type === 'IMAGE')
          .map((sticker: any) => (
            <div key={sticker.label} className='item_flag'>
              <img src={sticker.label} alt='' />
            </div>
          ))}
        <div
          onClick={(e) => {
            handleNavigation(e)
          }}
        >
          <div className='dim'></div>
          <img src={data.listImageUrls?.[0]} alt='' onError={onErrorImg} />
        </div>
      </div>

      {/* 장바구니 버튼 */}
      <BtnCart
        className='btn_cart'
        onClick={() => {
          setIsModal(true)
          if (data.productNo) {
            setSelectProductNo(data.productNo?.toString())
          }
          setCartIdx(index)
        }}
      >
        {data.isSoldOut ? (
          '재입고 알림'
        ) : (
          <>
            <img src={`${IMAGE_PATH}/icon_cart.png`} alt='' /> 장바구니
          </>
        )}
      </BtnCart>

      <div
        className='product_item'
        onClick={(e) => {
          handleNavigation(e)
        }}
      >
        {/* 브랜드명 */}
        {data.brandName && <ProductBrandTitle>{data.brandName}</ProductBrandTitle>}
        {/* 상품명 */}
        <ProductTitle>{data.productName}</ProductTitle>

        {/* 가격 정보
        <ProductSalePrice>{plusComma(data.salePrice)}원</ProductSalePrice> */}

        {Math.floor(((data?.immediateDiscountAmt || 0) / (data?.salePrice || 0)) * 100) === 0 ? (
          <div className='discounted_price'>
            {/* 상품 할인 적용가 */}
            <p>{plusComma((data?.salePrice || 0) - (data?.immediateDiscountAmt || 0))}원</p>
          </div>
        ) : (
          <>
            <div className='product_sale_price'>{plusComma(data?.salePrice)}원</div>
            <div className='discounted_price'>
              <p className='percent'>
                {Math.floor(((data?.immediateDiscountAmt || 0) / (data?.salePrice || 0)) * 100)}%
              </p>
              {/* 상품 할인 적용가 */}
              <p>{plusComma((data?.salePrice || 0) - (data?.immediateDiscountAmt || 0))}원</p>
            </div>
          </>
        )}
        {/* {data.accumulationInfo?.amount != null && data.accumulationInfo?.amount > 0 && (
          <MaximumBenefit>
            <p className="badge">회원혜택가</p>
            <p>
              {plusComma(
                calculateDiscountPrice() - (data.couponDiscountAmt || 0) - data.accumulationInfo.amount - disCountAcc,
              )}
              원
            </p>
          </MaximumBenefit>
        )} */}
        {/* <div className="discounted_price">
          {data.immediateDiscountAmt ? (
            <>
              <p className="percent">{Math.round((data.immediateDiscountAmt / (data.salePrice || 1)) * 100)}%</p>
              <p>{plusComma(calculateDiscountPrice())}원</p>
            </>
          ) : (
            <p>{plusComma(data.salePrice)}원</p>
          )}
        </div> */}

        {/* 최대 혜택가 */}
        {!data?.accumulationUseInfo?.usable && !data.enableCoupons
          ? null
          : calculateDiscountPrice() -
              (data.couponDiscountAmt || 0) -
              (data?.accumulationInfo?.amount || 0) -
              (data?.accumulationUseInfo?.usable ? disCountAcc : 0) ===
            Number((data.salePrice || 0) - (data.immediateDiscountAmt || 0))
          ? null
          : data.accumulationInfo?.amount != undefined && (
              <MaximumBenefit>
                <p className='badge'>회원혜택가</p>
                <p>
                  {plusComma(
                    calculateDiscountPrice() -
                      (data.couponDiscountAmt || 0) -
                      data.accumulationInfo.amount -
                      (data.accumulationInfo.amount === 0 ? 0 : disCountAcc) <
                      0
                      ? 0
                      : calculateDiscountPrice() -
                          (data.couponDiscountAmt || 0) -
                          data.accumulationInfo.amount -
                          (data.accumulationInfo.amount === 0 ? 0 : disCountAcc)
                  )}
                  원
                </p>
              </MaximumBenefit>
            )}

        {/* 적립금 */}
        {hasAccessToken && data.accumulationInfo?.amount && data.accumulationInfo?.amount > 0 ? (
          <div className='save_mileage'>
            <p>
              {`페이백 적립금 ${data.accumulationInfo.rewardRateOfProduct}% `}
              {plusComma(data.accumulationInfo.amount)}
              <img src={`${IMAGE_PATH}/icon_point.png`} alt='Point' />
            </p>
          </div>
        ) : null}

        {/* 별점 */}
        <StarRating>
          <IconStarOn width={isMobile ? 14 : 16} height={isMobile ? 14 : 16} />
          <span className='review_rating'>{data.reviewRating}</span>
          <span className='review_num'>({data.totalReviewCount})</span>
          <div className='npay'>
            <img src={`${IMAGE_PATH}/icon_npay.png`} alt='Naver Pay' />
          </div>
        </StarRating>

        {/* 오늘 특가 등 텍스트 표시 */}
        <div className='item_txt_flag_detail'>
          {data.stickerInfos
            ?.filter((sticker: any) => sticker.type === 'TEXT')
            .map((sticker: any) => (
              <span key={sticker.label} className='delivery'>
                {sticker.label}
              </span>
            ))}
        </div>
      </div>
    </div>
  )
}

// 스타일 컴포넌트
const ProductBrandTitle = styled.div`
  color: var(--colBlack);
  font-size: 12px;
  font-weight: 600;
  line-height: 14px;
  margin-bottom: 4px;
  @media screen and (min-width: 768px) {
    font-size: 14px;
    line-height: 16px;
    margin-bottom: 6px;
  }
`

const ProductTitle = styled.div`
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  color: var(--colBlack);
  display: -webkit-box;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  margin-bottom: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  @media screen and (min-width: 768px) {
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 10px;
  }
`

const BtnCart = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 7px;
  margin-bottom: 10px;
  border-radius: 4px;
  font-size: 14px;
`

const ProductSalePrice = styled.div`
  color: var(--colGray5);
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  text-decoration-line: line-through;
  @media screen and (min-width: 768px) {
    font-size: 14px;
    margin-bottom: 2px;
  }
`

const MaximumBenefit = styled.div`
  display: flex;
  align-items: center;
  margin-top: 5px;
  gap: 4px;
  & .badge {
    align-items: center;
    background: var(--colPointOrange);
    border-radius: 8px;
    color: var(--colWhite);
    display: flex;
    font-size: 10px;
    font-weight: 600;
    height: 16px;
    justify-content: center;
    line-height: 11px;
    padding: 0 6px;
  }
  p {
    color: var(--colPointOrange);
    font-size: 15px;
    font-weight: 600;
    line-height: 16px;
  }
  @media screen and (min-width: 768px) {
    & .badge {
      border-radius: 22px;
      font-size: 12px;
      height: 22px;
    }
    p {
      color: var(--colPointOrange);
      font-size: 15px;
      font-weight: 600;
      line-height: 16px;
    }
  }
`

const StarRating = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 10px;
  & span {
    display: inline-block;
  }
  & .review_rating {
    color: var(--colBlack);
    font-size: 14px;
    font-weight: 600;
    line-height: 14px;
    margin-left: 2px;
  }
  & .review_num {
    color: var(--colGray5);
    font-size: 13px;
    font-weight: 500;
    height: 14px;
    line-height: 14px;
    margin-left: 4px;
    padding-top: 0.5px;
  }
  @media screen and (min-width: 768px) {
    & .review_rating {
      color: var(--colBlack);
      font-size: 16px;
      line-height: 16px;
    }
    & .review_num {
      color: var(--colGray5);
      font-size: 14px;
      font-weight: 500;
      height: 16px;
      line-height: 15px;
      padding-top: 0.5px;
      margin-left: 4px;
    }
  }
`

export default ProductItem
